export const MODAL_TYPES = {
  INVITE_TO_COMBAT_TAKING: 'INVITE_TO_COMBAT_TAKING',
  EXIT_COMBAT_TAKING: 'EXIT_COMBAT_TAKING',
  QUESTION_SOLUTION_VIDEO: 'QUESTION_SOLUTION_VIDEO',
  COMBAT_LANGUAGE_SELECTION: 'COMBAT_LANGUAGE_SELECTION',
  SHOW_COMBAT_DETAILS: 'SHOW_COMBAT_DETAILS',
  SHOW_INVITE_CODE_DRAWER: 'SHOW_INVITE_CODE_DRAWER'
};

export const TAKING_SCREENS = {
  INIT_TICKER: 'INIT_TICKER',
  POLL: 'POLL',
  LEADERBOARD: 'LEADERBOARD',
  QUESTION: 'QUESTION',
  ANSWER: 'ANSWER',
  SUMMARY: 'SUMMARY',
  ROUND_SUMMARY: 'ROUND_SUMMARY'
};

export const QUESTION_TYPES = {
  SINGLE: 'SINGLE_CHOICE',
  MCQ: 'MULTI_CHOICE',
  INTEGER: 'NUMERIC'
};

export const COMBAT_TYPES = {
  ALL: 0,
  PAST: 1,
  UPCOMING: 3
};
